import React, { useState } from 'react';
import './Cart.scss';
import Header from '../Header/Header';
import close from "../../assets/close.svg"
import Button from '../Button/Button';
import CartItem from './CartItem/CartItem';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from "react-redux";
import { setCart } from '../../../../../../../redux/companyDataSlice';
import Modal from '../Modal/Modal';

const Cart = ({ isOpen, setIsOpen, setIsShowLoginModal }) => {
    const history = useHistory()
    const dispatch = useDispatch()

    const cart = useSelector((state) => state.companyData.cart)
    const [selectedItem, setSelectedItem] = useState("")
    const toggleDrawer = () => {
        setIsOpen(!isOpen);
    };
    const handleDelete = (item) => {
        const updated = cart.filter((product) => product.ProductID !== item.ProductID)
        dispatch(setCart(updated))
        setSelectedItem("")
    }
    const increaseQty = (product) => {
        if (product) {
            const updated = cart.map(item =>
                item.ProductID === product.ProductID
                    ? { ...item, ProductQty: item.ProductQty ? item.ProductQty + 1 : 1 }
                    : item
            );
            dispatch(setCart(updated))
        }
    };
    const decreaseQty = (product) => {
        if (product && product.ProductQty > 1) {
            const updated = cart.map(item =>
                item.ProductID === product.ProductID
                    ? { ...item, ProductQty: item.ProductQty - 1 }
                    : item
            );
            dispatch(setCart(updated))
        } else {
            setSelectedItem(product)
            toggleDrawer()
        }
    };
    const getTotalPrice = () => {
        const total = cart.reduce((sum, item) => {
            const qty = item.ProductQty || 0;
            const price = item.ProductPrice || 0;
            return sum + qty * price;
        }, 0);
        return total.toFixed(2);
    };
    return (
        <div className="sliding-drawer-container">
            <div className={`drawer ${isOpen ? 'open' : ''}`}>
                <div className="drawer-content">
                    <div className='header-conatiner'><Header text={"Item added to your cart"} fontSize={"18px"} />
                        <div className='close-cont' onClick={toggleDrawer} ><img alt='' src={close} /></div></div>
                    {cart.length === 0 && <div className='empty-cart'>
                        <Header text={"Your cart is empty"} fontSize={"22px"} />
                        <Button text={"Continue Shopping"} invert width={"100%"}
                            onClick={() => {
                                toggleDrawer()
                            }} />

                    </div>}
                    <div className='cart-container'>
                        {cart.map((product, key) => {
                            return (
                                <CartItem item={product} key={key} onDelete={() => {
                                    setSelectedItem(product)
                                    toggleDrawer()
                                }}
                                    increaseQty={() => { increaseQty(product) }} decreaseQty={() => {
                                        decreaseQty(product)
                                    }} />

                            )
                        })}
                    </div>
                </div>
                {cart.length > 0 && <div className='bottom-container-div'>
                    <div className='price-container'>
                        <Header text="Subtotal" fontSize={"26px"} />
                        <div className='price-cont'> £ {getTotalPrice()}</div>
                    </div>
                    <div className='button-container'>
                        <Button text={"Back"} invert width={"100%"}
                            onClick={() => {
                                toggleDrawer()
                            }} />
                        <Button text={"Check Out"} width={"100%"} onClick={() => {
                            if (localStorage.getItem('isLogged') === 'true') {
                                history.push("/pages/checkout")
                            } else {
                                toggleDrawer()
                                setIsShowLoginModal(true)
                            }
                        }} />
                    </div>

                </div>}
            </div>
            {selectedItem !== "" && <Modal isRemovecrt header={"Delete This Item?"} subText={"Are you sure want to remove it from cart?"} buttonText="Remove"
                onClick={() => {
                    handleDelete(selectedItem)

                }}
                onCancel={() => {
                    setSelectedItem("")
                }} />}
        </div>
    );
};

export default Cart;
